import { useContext } from "react";
import CrudContext from "../../context/crudContext";
import FilterContext from "../../context/filterContext";
import styles from "../../styles/table.module.css";
import FilterSearch from "../FilterSearch";
import CrudTableRow from "./crudTableRow";

export default function CrudTable() {
  const { db: data } = useContext(CrudContext);
  const { filter, category } = useContext(FilterContext);

  let filtroSearch =
    data.Product &&
    data.Product.filter((el) => {
      if (!filter) return true;
      const name = el.pro_name.toLowerCase();
      return name.includes(filter.toLowerCase());
    });

  return (
    <>
      <FilterSearch />

      <div className={styles.tableContainer}>
        <div className={styles.table}>
          <div className="table-responsive">
            <table className="table table-hover  table-bordered">
              <thead className="thead-info text-center">
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Categoria</th>
                  <th scope="col">Proveedor</th>
                  <th scope="col">N. de existencias</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Descripción</th>
                  <th scope="col">Opciones</th>
                </tr>
              </thead>
              <tbody className={styles.tBody}>
                {filter ? (
                  data.Product && filtroSearch.length > 0 ? (
                    filtroSearch.map((el) => (
                      <CrudTableRow key={el.pro_id} el={el} />
                    ))
                  ) : (
                    <tr style={{ padding: "1.5rem" }}>
                      <td colSpan="8">No se encontraron coincidencias</td>
                    </tr>
                  )
                ) : (
                  data.Product &&
                  data.Product.filter((el) => {
                    if (!category) return true;
                    const name = el.pro_category;
                    return name.includes(category);
                  }).map((el) => <CrudTableRow key={el.pro_id} el={el} />)
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
